// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estimate-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.estimate-header h2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/routes/estimate/estimate.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACJ","sourcesContent":[".estimate-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  h2 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 16px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
